import { render, staticRenderFns } from "./show.vue?vue&type=template&id=3025ae2d&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"
import style0 from "./show.vue?vue&type=style&index=0&id=3025ae2d&prod&lang=scss"
import style1 from "./show.vue?vue&type=style&index=1&id=3025ae2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3025ae2d",
  null
  
)

export default component.exports